export default __webpack_public_path__ + "static/media/wooli.08085618.png";